import { apiSlice } from "./apiSlice";

export const boxApi = apiSlice
    .enhanceEndpoints({ addTagTypes: ['BOX'] })
    .injectEndpoints({
        keepUnusedDataFor: 1,
        endpoints: builder => ({
            getBoxes: builder.query({
                query: (params) => ({
                    url: `/box`,
                    method: 'GET',
                    params
                }),
                providesTags: [{ type: 'BOX', id: 'BOX-PARTIAL-LIST' }],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            getBoxById: builder.query({
                query: (id) => ({
                    url: `/box/${id}`,
                    method: 'GET'
                }),
                providesTags: (_, __, id) => [{ type: "BOX", id }],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            createBox: builder.mutation({
                query: (payload) => ({
                    url: `/box`,
                    method: 'POST',
                    body: { ...payload }
                }),
                invalidatesTags: [
                    { type: "BOX", id: "BOX-PARTIAL-LIST" },
                ],
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            updateBox: builder.mutation({
                query: ({ id, payload }) => ({
                    url: `/box/${id}`,
                    method: 'PUT',
                    body: { ...payload }
                }),
                invalidatesTags: (_, __, { id }) => [
                    // { type: "BOX", id },
                    { type: "BOX", id: "BOX-PARTIAL-LIST" },
                ],
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
            deleteBox: builder.mutation({
                query: (id) => ({
                    url: `/box/${id}`,
                    method: 'DELETE'
                }),
                invalidatesTags: (_, __, id) => [
                    // { type: "BOX", id },
                    { type: "BOX", id: "BOX-PARTIAL-LIST" },
                ],
                transformResponse: (response, meta, arg) => response?.body,
                transformErrorResponse: (response, meta, arg) => response?.data?.message ?? "Something went wrong please try again",
            }),
        })
    })

export const {
    useGetBoxesQuery,
    useGetBoxByIdQuery,
    useCreateBoxMutation,
    useUpdateBoxMutation,
    useDeleteBoxMutation,
} = boxApi